import { Component, OnInit } from "@angular/core";
import { Storage } from "@ionic/storage-angular";
import { Platform } from "@ionic/angular";
import { Navigator } from "src/app/components/menu/navigator";
import { AppLinksService } from "src/app/services/applinks/app-links.service";
import { BiometricService } from "src/app/services/biometric/biometric.service";
import { ConfigService } from "src/app/services/config/config.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { CustomerModel } from "src/app/models/customer-model";
import { App } from "@capacitor/app";

@Component({
  selector: "app-account-information",
  templateUrl: "./account-information.component.html",
  styleUrls: ["./account-information.component.scss"],
})

export class AccountInformationComponent implements OnInit {

  public advertisingID: string;
  public appName: string;
  public clientApp: string;
  public councilLink: string;
  public councilLinkName: string;
  public councilLinkText: string;
  public customer: CustomerModel;
  public deviceId: string;
  public env: string;
  public isIOSApp: boolean = false;
  public isMobileApp: boolean;
  public isTestAccount: boolean = false;
  public joinDate: any;
  public lastIPAddress: any;
  public lastLoginTime: any;
  public lastLogoutReason: any;
  public packageName: string;

  public PIPE_DATE_FORMAT = !!this.config.getConfig().FEATURE_TIME_FORMAT_TIME_STAMP ? this.config.getConfig().FEATURE_TIME_FORMAT_TIME_STAMP : 'MM-dd-yyyy, hh:mm a';
  public selfExclusionPage: string;
  public touchIDLabel: string = "Biometric/Face ID";
  public useTouchID: boolean = false;
  public versionCode: string | number;
  public versionNumber: string;

  constructor(
    public appLinks: AppLinksService,
    public biometricService:  BiometricService,
    public config: ConfigService,
    public navigator: Navigator,
    public platform: Platform,
    public storage: Storage,
    public userSession: UserSessionService,
    public utils: UtilsService,
  ){
    this.getCustomer();
  }

  private getCustomer() {
    this.userSession.getCustomer().subscribe(
      (customer) => {

        if (customer) {
          this.customer = customer;
          if (customer.lastLoginTime) {
            this.lastLoginTime = customer.lastLoginTime;
          }
          if (customer.createdDate) {
            this.joinDate = customer.createdDate;
          }
          this.isTestAccount = this.customer.testAccount;
        }
      },(err) => {
        console.error("getCustomer", err);
      }
    );
  }

  async ngOnInit() {

    let appConfigInfo = this.config.getConfig();
    this.councilLink = appConfigInfo.COUNCIL_LINK || "https://www.connexontario.ca/en-ca/";
    this.councilLinkName = appConfigInfo.COUNCIL_LINK_NAME || "Mental Health & Addiction Treatment Services | Connex Ontario";
    this.councilLinkText = appConfigInfo.COUNCIL_LINK_TEXT ||
    "If you need help you can visit the";
    // for ontario it's: "If you or someone you know has a gambling problem and needs help, call ConnexOntario at 1-866-531-2600 or visit"
    this.selfExclusionPage = appConfigInfo.self_exclusion_page;

    await this.storage.create();
    this.storage.get("lastIPAddress").then((lastIPAddress) => {
      this.lastIPAddress = lastIPAddress;
    });

    this.storage.get("lastLogoutReason").then((lastLogoutReason) => {
      if (
        lastLogoutReason == "GAME_CLT_LOGOUT" ||
        lastLogoutReason == "APP_INACTIVITY"
      ) {
        this.lastLogoutReason = lastLogoutReason;
      }
    });

    this.versionNumber = "N/A";

    this.clientApp = this.config.getClientApp();

    if (this.platform.is("capacitor")) {
      this.isMobileApp = true;
      const info = await App.getInfo()
      this.versionNumber = info.version;

      this.env = this.config.getEnv().env;

      if (this.platform.is("ios")) {
        this.isIOSApp = true;
      }
    } else {
      this.isMobileApp = false;
    }
  }

  openPage(page) {
    this.navigator.navigateTo(page, { multipleModals: true });
    return false;
  }

  clearTouchID() {
    this.biometricService.deleteCredentials();
    this.useTouchID = false;
  }

  goToCouncilLink() {
    this.appLinks.openExternalPage(this.councilLink);
    return false;
  }
}
